module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9545.f8f5bfb0.jpg";